<flx-expandable-table
  [columns]="scrollableTokensTableCols()"
  [value]="hierarchicalTokens()"
  [expandableFields]="expandableFields"
  [frozenColumns]="frozenColumns()"
  [frozenColumnsWidth]="frozenColumnsWidth()"
  class="shrink min-h-64"
  emptyMessage="No Tokens found"
/>

<ng-template
  [flxShowModal]="showTokenModal"
  (backdropClick)="hideTokenDetailsModal()"
>
  <flx-modal
    [dismissible]="true"
    (dismiss)="hideTokenDetailsModal()"
    class="flx-ds large"
  >
    <div
      class="flx-modal-title"
      flxModalHeaderTitle
    >
      Token status
    </div>
    <div class="flex flex-col overflow-auto px-8 grow">
      @if (selectedToken) {
        <flx-json-viewer
          [json]="selectedToken"
          [expanded]="false"
          class="pb-8"
        >
        </flx-json-viewer>
      } @else {
        <flx-spinner
          [radius]="30"
          class="flex items-center justify-center"
          visualType="custom"
          size="small"
        ></flx-spinner>
      }
    </div>
  </flx-modal>
</ng-template>

<ng-template
  #uuid
  let-token
>
  <div class="w-40 flex items-center">
    <p class="w-16 truncate">{{ token.uuid }}</p>
    <button
      [cdkCopyToClipboard]="token.uuid"
      (cdkCopyToClipboardCopied)="onCopyToClipboardSuccess(token.uuid)"
      class="flx-ds text-neutral-500 small ternary -ml-2"
      flxButton
      icon="center"
    >
      <i
        class="ph ph-copy"
        flxIcon
      ></i>
    </button>
  </div>
</ng-template>
<ng-template
  #tokenStatus
  let-token
>
  @let statusTranslated = TokenAndNodesStatusTagTypeMap[token.state] ?? { title: token.state };
  <ng-container *ngTemplateOutlet="status; context: { $implicit: statusTranslated }"></ng-container>
</ng-template>

<ng-template
  #currentNodeStatus
  let-token
>
  @let statusTranslated =
    TokenAndNodesStatusTagTypeMap[token.statusCurrentNode] ?? { title: token.statusCurrentNode };
  <ng-container *ngTemplateOutlet="status; context: { $implicit: statusTranslated }"></ng-container>
</ng-template>

<!-- Local variant of token status. If this variant is approved to be used elsewhere, it should a component -->
<ng-template
  #status
  let-status
>
  <div
    [class]="status.class"
    [ngClass]="{
      'text-green-500 bg-green-50': status.class === 'success',
      'text-orange-500 bg-orange-50': status.class === 'warning',
      'text-red-500 bg-red-50': status.class === 'danger',
      'text-blue-500 bg-blue-50': status.class === 'info',
      'text-yellow-500 bg-yellow-50': status.class === 'primary',
      'bg-neutral-50 text-neutral-500': !status.class,
    }"
    [pTooltip]="status.tooltip"
    [tooltipDisabled]="!status.tooltip"
    class="px-4 text-sm leading-[22px] font-semibold rounded-2xl"
    tooltipStyleClass="text-xs"
  >
    {{ status.title }}
  </div>
</ng-template>
<ng-template
  #tokenDate
  let-token
>
  {{ token.dateUpdated | date: 'dd MMM yyyy h:mm:ss.SSS a ' }}
</ng-template>

<ng-template
  #actions
  let-token
>
  <div class="w-full flex justify-end gap-2">
    <button
      [disabled]="retryInProgress()"
      [class]="canRetry() && token.state === TOKEN_STATE.ACTIVE ? '' : 'invisible'"
      (click)="retryToken(token)"
      class="flx-ds secondary"
      pTooltip="Retry"
      flxButton
      icon="center"
    >
      <i
        class="ph ph-arrow-u-up-right text-neutral-900"
        flxIcon
      ></i>
    </button>
    <button
      (click)="showTokenDetailsModal(token)"
      class="flx-ds secondary"
      flxButton
      icon="center"
    >
      <i
        class="ph ph-eye text-neutral-900"
        flxIcon
      ></i>
    </button>
  </div>
</ng-template>
